/* eslint-disable react/sort-comp */
/* eslint-disable react/no-deprecated */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';

import { Divider, List, ListItem, ListItemIcon, ListItemText } from '@material-ui/core';
import { ChevronRight } from '@material-ui/icons';
import { styles } from './Configurations.styles';
import 'rc-time-picker/assets/index.css';
import 'react-datepicker/dist/react-datepicker.css';
import { version } from '../../../package.json';
import { Title, Paper } from '../../components';
import * as actions from '../../actions/index';
import { settings } from '../../constants/mainViewList';
import { checkAccess } from '../../utils/admins';
import {
  mainColor,
  DELIVERY_HOUR_ROUTE,
  HUBRISE_ROUTE,
  PRINTER_ROUTE,
  PAYMENTS_ROUTE,
  SALES_TYPE_ROUTE,
  DELIVERY_SETTINGS_ROUTE,
  ORDER_SETTINGS_ROUTE,
  MANAGEMENT_FEE_ROUTE
} from '../../constants';

class Configurations extends Component {
  render() {
    const {
      classes,
      chatbot,
      mobileApp,
      webapp,
      configurations,
      dashboardConfig,
      showHelpModal,
      sidebarCollapse,
      isAllShops,
      nbShops
    } = this.props;
    const { printer } = dashboardConfig;
    const { configuration = {} } = configurations;
    const { orderTypes, externalIntegration = {} } = configuration;
    const { configuration: externalIntegrationConfiguration = {} } = externalIntegration;
    const { show = false } = externalIntegrationConfiguration;
    const deliveryTech = mobileApp.enabled || webapp.enabled || chatbot.enabled;
    const deliverySlots = orderTypes && orderTypes.includes('delivery') && deliveryTech;
    const sections = _.filter(settings, setting => {
      const { url } = setting;
      if (isAllShops)
        return (
          url === SALES_TYPE_ROUTE ||
          url === PAYMENTS_ROUTE ||
          url === DELIVERY_SETTINGS_ROUTE ||
          url === ORDER_SETTINGS_ROUTE ||
          url === MANAGEMENT_FEE_ROUTE
        );
      return (
        (deliverySlots && url === DELIVERY_HOUR_ROUTE) ||
        (show && url === HUBRISE_ROUTE) ||
        ((!printer || printer.type === 'QZ') && url === PRINTER_ROUTE) ||
        (url === MANAGEMENT_FEE_ROUTE && nbShops === 1) ||
        (url === DELIVERY_SETTINGS_ROUTE && checkAccess('features', 'deliverySettings')) ||
        (url === MANAGEMENT_FEE_ROUTE && nbShops === 1) ||
        ![
          DELIVERY_HOUR_ROUTE,
          HUBRISE_ROUTE,
          PRINTER_ROUTE,
          DELIVERY_SETTINGS_ROUTE,
          MANAGEMENT_FEE_ROUTE
        ].includes(url)
      );
    });

    return (
      <div className='px-4 pb-4'>
        <Title title='Réglages' onClick={() => showHelpModal('reglages')} />
        <div
          className={`col-12 ${sidebarCollapse &&
            'col-lg-10'} flex-row justify-content-cenetr align-items-center px-0 `}
        >
          <div className='col-md-12 p-0'>
            <Paper>
              <List>
                {_.map(sections, (setting, index) => {
                  return (
                    <Link
                      key={index}
                      style={{ color: 'transparent' }}
                      to={{
                        pathname: `${setting.url}`,
                        state: { title: setting.text, subtitle: setting.description }
                      }}
                    >
                      <ListItem button className={classes.gutters}>
                        <ListItemIcon>{setting.icon}</ListItemIcon>
                        <ListItemText
                          style={{ color: mainColor.colorBlack }}
                          primary={setting.text}
                          secondary={setting.url === ORDER_SETTINGS_ROUTE && isAllShops ? setting.description.replace('.', ' de tous les magasins.') : setting.description}
                        />
                        <ChevronRight style={{ color: mainColor.colorBlack }} />
                      </ListItem>
                      {index <= sections.length - 2 && <Divider variant='inset' component='li' />}
                    </Link>
                  );
                })}
              </List>
            </Paper>
            <p className={classes.versionText}> Version: {version} </p>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps({ user, firebaseRealTime, sidebar }) {
  const { dashboardConfig, isAllShops, nbShops } = user;
  const { generalConfig, shop } = firebaseRealTime;
  const {
    paymentTypes,
    terminal = {},
    chatbot = {},
    mobileApp = {},
    qrcode = {},
    webapp = {}
  } = generalConfig;
  const { sidebarCollapse } = sidebar;
  return {
    configurations: shop,
    dashboardConfig,
    paymentTypes,
    terminal,
    chatbot,
    mobileApp,
    qrcode,
    webapp,
    sidebarCollapse,
    nbShops,
    isAllShops
  };
}
Configurations.propTypes = {
  classes: PropTypes.element.isRequired
};

export default connect(mapStateToProps, actions)(withStyles(styles)(withRouter(Configurations)));
